import React, { useState, useEffect } from "react";
import { PageWrapper, InnerWrapper } from "./styles";
import { promoCode2Pennies } from "../utils/validate";
import { sendPUT } from "../utils/comm";
import { CurrentPricePennies, ListPricePennies } from "../utils/pricing";

export const PrePayment = ({ surveyResult, setFinished }) => {
  const [dataChanged, setDataChanged] = useState(false);
  const [promoAlert, setPromoAlert] = useState();
  const [complete, setComplete] = useState(false);
  const [pennies, setPennies] = useState(0);

  useEffect(() => {
    let element = document.getElementById("ScrollToTop");
    console.log("element:", element);
    try {
      element.scrollIntoView();
    } catch (e) {
      console.error("Scoll not working:", e);
    }
  }, [complete]);

  if (complete) {
    // Skip credit card processing if pennies is 0
    if (pennies === 0) {
      window.location.href = "/success/" + surveyResult.dateValue + "/0";
    } else {
      setFinished("done");
    }
  }

  if (dataChanged) {
  } // avoid compiler warning

  return (
    <PageWrapper>
      <InnerWrapper
        style={{ width: "70%", margin: "auto", padding: "1em 2em" }}
      >
        <div id="ScrollToTop"></div>
        <h1>
          Your RootFinder<sup>TM</sup> Report is Ready
        </h1>
        <p>
          Thank you for completing our RootFinder questionnaire. We have
          processed and analyzed your responses and have identified the most
          likely root causes for your conditions, their likelihood score, and an
          Illness Index. Please tap on the Buy button below and we will forward
          your Personalized Root Cause Analysis Report to the email address you
          have provided.
        </p>
        <p>
          If you have a Promo Code, please enter here:&nbsp;
          <input
            size={30}
            type="text"
            defaultValue={surveyResult.promo}
            onChange={(e) => {
              surveyResult.promo = e.target.value;
              setDataChanged(true); // I dont know why I'm setting this...
            }}
          />
        </p>
        {promoAlert ? <div style={{ color: "red" }}>{promoAlert}</div> : null}
        <div style={{ margin: "auto" }}>
          <h2>Get your Personalized Report</h2>
          <div style={{ marginLeft: "30px" }}>
            <b>
              <h3 style={{ marginLeft: "30px" }}>
                <span style={{ textDecoration: "line-through" }}>
                  {" "}
                  ${ListPricePennies / 100}{" "}
                </span>
                <span style={{ color: "red" }}>
                  &nbsp;${CurrentPricePennies / 100}
                  <small>
                    {" "}
                    (
                    {Math.trunc(
                      (1 - CurrentPricePennies / ListPricePennies) * 100
                    )}
                    % discount)
                  </small>
                </span>
              </h3>
            </b>
            <ul>
              <li>
                Detailed 10+ page report based on{" "}
                <b>
                  <i>your</i>
                </b>{" "}
                issues
              </li>
              <li>Top five most likely root causes of your health issues</li>
              <li>
                Your overall Illness Index<sup>TM</sup>
              </li>
              <li>Recommended next steps</li>
              <li>Personalized report emailed to you within minutes</li>
              <li>Satisfaction guaranteed</li>
            </ul>
          </div>
          <div>
            <span
              style={{
                //marginLeft: "130px",
                textAlign: "center",
                color: "black",
                backgroundColor: "red",
                maxWidth: "2em",
                padding: "10px 30px",
                cursor: "pointer",
                fontSize: "2em",
                fontWeight: "bold",
                borderRadius: "10px",
              }}
              onClick={async (e) => {
                e.preventDefault();
                let pennies = promoCode2Pennies(
                  surveyResult.promos,
                  surveyResult.promo
                );
                if (pennies == null) {
                  setPromoAlert(
                    "Invalid promo code; please respecify or remove"
                  );
                  return;
                }
                console.log("...updating server...");
                await sendPUT(
                  "/result/" + surveyResult.dateValue,
                  surveyResult
                );
                setPennies(pennies);
                setComplete(true); // Why? We need a chance to scroll-to-top
              }}
            >
              BUY
            </span>
            <span style={{ marginLeft: "1em" }}>
              Click{" "}
              <a
                href="https://complexhealthsolutions.com/pdf/complexhealthreport_41522.pdf"
                target="_blank"
              >
                HERE
              </a>{" "}
              to see a sample detailed report!
            </span>
          </div>
        </div>
        <div
          style={{
            fontSize: "0.8em",
            lineHeight: "1.4em",
            marginTop: "1em",
            marginBottom: "2em",
          }}
        >
          * Please note:<br></br>
          &nbsp;&nbsp;- Special pricing is a limited time offer and subject to
          change at any time. <br></br>
          &nbsp;&nbsp;- Should you not be satisfied with your purchase, we will
          offer you credit towards taking our questionnaire in the future. We
          cannot offer a refund since we do not maintain your personal
          identification or credit card info.
        </div>
      </InnerWrapper>
    </PageWrapper>
  );
};
